import { CAPABILITIES, CAPABILITY_LABEL, ROLE_LABEL, capabilitiesOf } from '@/lib/auth'
import { useAuth } from '@/lib/auth/use-auth'
import { Badge } from '@/components/ui/Badge'

/**
 * Placeholder so the sign-in / sign-out flow runs end to end and the
 * permission matrix is verifiable. Replaced by the Gantt and dashboard
 * in Phase 1–2.
 */
export function DashboardPage() {
  const { session } = useAuth()
  if (!session) return null

  const { user } = session
  const granted = new Set(capabilitiesOf(user.role))

  return (
    <div className="max-w-[1200px]">
      <p className="t-caption-strong text-muted">
        {new Date()
          .toLocaleDateString('en-GB', {
            weekday: 'short',
            day: '2-digit',
            month: 'short',
            year: 'numeric',
          })
          .toUpperCase()}
      </p>
      <h1 className="t-title-lg mt-2 text-ink">{user.fullName}</h1>

      <div className="mt-4 flex flex-wrap items-center gap-3">
        <Badge>{ROLE_LABEL[user.role]}</Badge>
        {user.shift && <span className="t-body-sm text-muted">{user.shift}</span>}
      </div>

      <section className="mt-12">
        <h2 className="t-title-md text-ink">Permissions</h2>

        <ul className="mt-6 grid gap-x-8 gap-y-1 sm:grid-cols-2">
          {CAPABILITIES.map((capability) => {
            const allowed = granted.has(capability)
            return (
              <li
                key={capability}
                className="flex items-center justify-between border-b border-hairline-soft py-3"
              >
                <span className={`t-body-sm ${allowed ? 'text-ink' : 'text-muted-soft'}`}>
                  {CAPABILITY_LABEL[capability]}
                </span>
                <span
                  className={`t-caption-strong ${
                    allowed ? 'text-semantic-up' : 'text-muted-soft'
                  }`}
                >
                  {allowed ? 'Yes' : '—'}
                </span>
              </li>
            )
          })}
        </ul>
      </section>
    </div>
  )
}
